<template>
    <v-container :fluid="true">
        <h1>Gestión de usuarios</h1>
        <v-row>
            <v-col cols="4">
                <v-card>
                    <v-card-text>
                        <!-- inicio del campo -->
                        <v-text-field
                        title="Nombre"
                        placeholder="Nombre del usuario"
                        clearable
                        v-model="dato.name"
                        >
                        </v-text-field>
                        <!-- fin del campo -->
                        <!-- inicio del campo -->
                        <v-text-field
                        title="Email"
                        placeholder="Email del usuario"
                        clearable
                        type="email"
                        v-model="dato.email"
                        >
                        </v-text-field>
                        <!-- fin del campo -->
                        <!-- inicio del campo -->
                        <v-text-field
                        title="Password"
                        placeholder="Password del usuario"
                        clearable
                        type="email"
                        v-model="dato.password"
                        >
                        </v-text-field>
                        <!-- fin del campo -->
                        <v-select
                        :items="roles"
                        item-title="rol"
                        item-value="id"
                        label="Rol"
                        clearable
                        placeholder="Rol del usuario"
                        v-model="dato.fk_rol"
                        ></v-select>
                        <v-btn prepend-icon="mdi-check" color="indigo" block @click="agregar">Agregar</v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="headers" :items="datos" class="custom-header">
                            <template #[`item.actions`]="{item}">
                                <v-btn icon="mdi-eye" @click="acciones(1,item.id)"></v-btn>
                                <v-btn icon="mdi-pencil" @click="acciones(2,item.id)"></v-btn>
                                <v-btn icon="mdi-delete" @click="acciones(3,item.id)"></v-btn>
                            </template>
                            <template #no-data>
                                <div class="text-center">
                                    <p>No hay usuarios</p>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
<!-- Dialogo para editar -->
<v-dialog v-model="dialogoEditar" transition="dialog-top-transition" width="500">
    <v-card title="Editar usuario">
        <v-card-text>
            <!-- inicio del campo -->
            <v-text-field
            title="Nombre"
            placeholder="Nombre del usuario"
            clearable
            v-model="dbdata.name"
            >
            </v-text-field>
            <!-- fin del campo -->
            <!-- inicio del campo -->
            <v-text-field
            title="Email"
            placeholder="Email del usuario"
            clearable
            type="email"
            v-model="dbdata.email"
            >
            </v-text-field>
            <!-- fin del campo -->
            <!-- inicio del campo -->
            <v-text-field
            title="Password"
            placeholder="Password del usuario"
            clearable
            type="email"
            v-model="dbdata.password"
            >
            </v-text-field>
            <!-- fin del campo -->
            <v-select
            :items="roles"
            item-title="rol"
            item-value="id"
            label="Rol"
            clearable
            placeholder="Rol del usuario"
            v-model="dbdata.fk_rol"
            ></v-select>
            <!-- Boton de guardar -->
            <v-btn
            prepend-icon="mdi-check"
            color="indigo"
            block
            @click="editar(dbdata.id)"
            >Guardar</v-btn>
        </v-card-text>
    </v-card>
</v-dialog>
<!-- dialogo para cer datos -->
<v-dialog v-model="dialogoVer" transition="dialog-top-transition" width="500">
    <v-card>
        <v-card-text>
            <v-list>
              <v-list-item prepend-icon="mdi-account" :title="dbdata.name"></v-list-item>
              <v-list-item prepend-icon="mdi-email" :title="dbdata.email"></v-list-item>
              <v-list-item prepend-icon="mdi-shield-account" :title="dbdata.rol"></v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</v-dialog>
<!-- Alerta rapida -->
<v-snackbar :timeout="1500" color="red-darken-4" v-model="alertaError"> "Algo salió mal!"</v-snackbar>
</template>
<script>
import Swal from 'sweetalert2';
import axios from 'axios';

export default{
    name:'UsersView',
    data(){
        return{
            //rutasdb
            url:'http://127.0.0.1:8000/api/users/',
            urlRole:'http://127.0.0.1:8000/api/roles',
            pwdkey:'3JAmksLh0YeObnNM',
            config:{
                headers:{
                    'Authorization':'Bearer '+this.$store.getters.getToken
                }
            },
             //autentificacion para metodos get
             params:{
                'params':{
                    pwd:'3JAmksLh0YeObnNM'
                }
            },
            // componente de la tabla
            datos:[],
            headers:[
                {title:'Nombre',value:'name'},
                {title:'Email',value:'email'},
                {title:'Rol',value:'rol'},
                {title:'Acciones',value:'actions'}
            ],
            // fin
            // variables de la base de datos
            dato:{},
            dbdata:{},
            roles:[],
            //variables de dialogos
            dialogoEditar:false,
            dialogoVer:false,
            alertaError:false
            // variables de plugins
        }
    },
    methods:{
        obtenerDominio(){
            this.url = `${this.$store.state.dominio}/users`;
            this.urlRole = `${this.$store.state.dominio}/roles`;
        },
        //alertas
        alerta(msg){
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
        },
        //acciones
        acciones(accion,id){
            switch (accion){
                case 1:
                    this.ver(id);
                    this.dialogoVer = true;
                    break;
                case 2:
                    this.ver(id)
                    this.dialogoEditar = true;
                    break;
                case 3:
                    this.eliminar(id);
                    break;
            }
        },
        //funciones de otras tablas
        obtenerRol(){
            axios
            .get(this.urlRole,this.params,this.config)
            .then((response) => {
                if (response.data.code == 200) {
                    this.roles = response.data.data;
                }
            })
            .catch((error) => console.log('ha ocurrido un error',error));
        },
        //crud
        obtener(){
            axios
            .get(this.url,this.params,this.config)
            .then((response) => {
                if (response.data.code == 200) {
                    this.datos =[];
                    this.datos = response.data.data;
                }
            })
            .catch((error) => console.log(error));
        },
        agregar(){
            this.dato.pwdkey = this.pwdkey;
            axios.post(this.url, this.dato,this.config)
            .then((response) => {
                if (response.data.code == 200) {
                    this.dato = {};
                    this.obtener();
                    this.alerta("Usuario agregado");
                }
            })
            .catch((error) =>{
                console.log(error);
            });
        },
        ver(id){
            axios
            .get(`${this.url}/${id}`,this.params,this.config)
            .then((response) => {
                if (response.data.code == 200) {
                this.dbdata = response.data.data;
                }
            })
            .catch((error) =>{
                this.alertaError = true;
                console.log('error al obtener usaurios',error)
            });
        },

        editar(id){
            this.dbdata.pwdkey = this.pwdkey;
            axios.put(`${this.url}/${id}`, this.dbdata,this.config)  
            .then((response) => {
                if (response.data.code == 200) {
                    this.dialogoEditar = false;
                    this.obtener();
                    this.alerta('Usuario actualizado!');
                }
            })
            .catch((error) =>{
                this.alertaError = true;
                console.log('Error al actulalizar usuarios',error)
            });
        },
        eliminar(id){
            Swal.fire({
                title: "Seguro que desea eliminar?",
                text: "Esta acción no se puede deshacer!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Borrar"
                }).then((result) => {
                if (result.isConfirmed) {
                    axios
                    .delete(`${this.url}/${id}`,this.params,this.config)
                    .then((response) => {
                        console.log(response);
                        if (response.data.code == 200) {
                            this.datos =[];
                            this.obtener();
                            this.alerta("Usuario eliminado");
                            
                        }
                    })
                    .catch((error) => console.log(error));
                   // 
                }
            });
        }
    },
    created(){
        this.obtenerDominio();
        this.obtener();
        this.obtenerRol();
    }
}
</script>
<style scoped>
.v-data-table {
    box-shadow: 1px 1px 5px  gray;
}
</style>